<template>
  <div class="h-100 row">
    <div class="h-100 text-center col-12" v-if="mode === 'start'">
      <div class="d-flex align-items-center justify-content-center h-25 row">
        <div class="text-secondary text-center col-12">
          <h1><i class="me-3 text-primary fas fa-hammer"></i>{{ dictionary.pageTitle }}</h1>
        </div>
      </div>
      <div class="d-flex align-items-stretch justify-content-center gap-2 py-3">
        <div :class="selected === 'A4' ? 'formTypeSelected' : ''" @click="formCardClick('A4')"
          class="d-flex align-items-center justify-content-center px-1 formTypeCard formTypeCardFull">
          <div class="my-3 text-center row">
            <div class="mb-4 col-12">
              <img style="width: 80px" src="assets/a4.png" alt="a4" />
            </div>
            <div class="col-12">
              <h4 class="fw-bold">Badge A4</h4>
              <p class="m-0">210 x 297 mm</p>
            </div>
          </div>
        </div>
        <div :class="selected === 'CR80' ? 'formTypeSelected' : ''" @click="formCardClick('CR80')"
          class="d-flex align-items-center justify-content-center px-1 formTypeCard formTypeCardFull">
          <div class="text-center row">
            <div class="mb-4 col-12">
              <img style="width: 80px" src="assets/credit-card.png" alt="credit card" />
            </div>
            <div class="col-12">
              <h4 class="fw-bold">Badge "Carte bleu"</h4>
              <p class="m-0">85,7 x 54,03 mm</p>
            </div>
          </div>
        </div>
        <div class="d-flex flex-column align-items-center gap-1">
          <div :class="selected === 'PapillonsV2' ? 'formTypeSelected' : ''" @click="formCardClick('PapillonsV2')"
            class="d-flex align-items-center justify-content-center px-1 formTypeCard formTypeCardFull formTypeCardStretch formTypeCardTop">
            <div class="text-center row">
              <div class="mb-2 mt-2 col-12">
                <h1 class="formPicto fas fa-bug"></h1>
              </div>
              <div class="col-12">
                <h4 class="fw-bold">Badge 8,6 x 12</h4>
                <p class="m-0 small fst-italic">"Coccinelle"</p>
                <p class="m-0">86 x 120 mm</p>
              </div>
            </div>
          </div>
          <div :class="selected === 'PapillonsV2-rv' ? 'formTypeSelected' : ''" @click="formCardClick('PapillonsV2-rv')"
            class="d-flex align-items-center justify-content-center formTypeCard formTypeCardFull formTypeCardRV">
            <span class="fw-bold">Recto verso différent</span>
          </div>
        </div>
        <div class="d-flex flex-column align-items-center gap-1">
          <div :class="selected === 'papillon' ? 'formTypeSelected' : ''" @click="formCardClick('papillon')"
            class="d-flex align-items-center justify-content-center px-1 formTypeCard formTypeCardFull formTypeCardStretch formTypeCardTop">
            <div class="text-center row">
              <div class="mt-2 mb-2 col-12">
                <h1 class="formPicto fas fa-cut"></h1>
              </div>
              <div class="col-12">
                <h4 class="fw-bold">Badge 10 x 12</h4>
                <p class="m-0 small fst-italic">"Papillon"</p>
                <p class="m-0">100 x 120 mm</p>
              </div>
            </div>
          </div>
          <div :class="selected === 'papillon-rv' ? 'formTypeSelected' : ''" @click="formCardClick('papillon-rv')"
            class="d-flex align-items-center justify-content-center formTypeCard formTypeCardFull formTypeCardRV">
            <span class="fw-bold">Recto verso différent</span>
          </div>
        </div>
        <div class="d-flex flex-column align-items-center gap-1">
          <div :class="selected === '100x130' ? 'formTypeSelected' : ''" @click="formCardClick('100x130')"
            class="d-flex align-items-center justify-content-center px-1 formTypeCard formTypeCardFull formTypeCardStretch formTypeCardTop">
            <div class="text-center row">
              <div class="mb-2 mt-2 col-12">
                <h1 class="formPicto fas fa-sheet-plastic"></h1>
              </div>
              <div class="col-12">
                <h4 class="fw-bold">Badge 10 x 13</h4>
                <p class="m-0">96,5 x 134 mm</p>
              </div>
            </div>
          </div>
          <div :class="selected === '100x130-rv' ? 'formTypeSelected' : ''" @click="formCardClick('100x130-rv')"
            class="d-flex align-items-center justify-content-center formTypeCard formTypeCardFull formTypeCardRV">
            <span class="fw-bold">Recto verso différent</span>
          </div>
        </div>
        <div :class="selected === 'import' ? 'formTypeSelected' : ''" @click="formCardClick('import')"
          class="d-flex align-items-center justify-content-center px-1 formTypeCard formTypeCardOutline">
          <div class="text-center row">
            <div class="col-12">
              <h1 class="formPicto fas fa-file-import"></h1>
            </div>
            <div class="col-12">
              <h4 class="fw-bold">Importer un badge</h4>
            </div>
          </div>
        </div>
      </div>
      <div class="d-flex align-items-stretch justify-content-center gap-2 pb-3">
        <div style="width: 220px" aria-hidden="true"></div>
        <div style="width: 220px" aria-hidden="true"></div>
        <div class="d-flex flex-column align-items-center gap-1">
          <div :class="selected === '86x120-bleed' ? 'formTypeSelected' : ''" @click="formCardClick('86x120-bleed')"
            class="d-flex align-items-center justify-content-center px-1 formTypeCard formTypeCardFull formTypeCardBeta formTypeCardStretch formTypeCardTop position-relative">
            <span class="formBetaBadge badge bg-warning text-dark">BETA</span>
            <div class="mt-4 mb-3 text-center row">
              <div class="col-12">
                <h4 class="fw-bold">Badge 8,6x12</h4>
                <p class="m-0 small">avec fond perdu</p>
              </div>
            </div>
          </div>
          <div :class="selected === '86x240-bleed' ? 'formTypeSelected' : ''" @click="formCardClick('86x240-bleed')"
            class="d-flex align-items-center justify-content-center formTypeCard formTypeCardFull formTypeCardBeta formTypeCardRV">
            <span class="fw-bold">Recto verso différent</span>
          </div>
        </div>
        <div class="d-flex flex-column align-items-center gap-1">
          <div :class="selected === '100x120-bleed' ? 'formTypeSelected' : ''" @click="formCardClick('100x120-bleed')"
            class="d-flex align-items-center justify-content-center px-1 formTypeCard formTypeCardFull formTypeCardBeta formTypeCardStretch formTypeCardTop position-relative">
            <span class="formBetaBadge badge bg-warning text-dark">BETA</span>
            <div class="mt-4 mb-3 text-center row">
              <div class="col-12">
                <h4 class="fw-bold">Badge 10x12</h4>
                <p class="m-0 small">avec fond perdu</p>
              </div>
            </div>
          </div>
          <div :class="selected === '100x240-bleed' ? 'formTypeSelected' : ''" @click="formCardClick('100x240-bleed')"
            class="d-flex align-items-center justify-content-center formTypeCard formTypeCardFull formTypeCardBeta formTypeCardRV">
            <span class="fw-bold">Recto verso différent</span>
          </div>
        </div>
        <div class="d-flex flex-column align-items-center gap-1">
          <div :class="selected === '96x134-bleed' ? 'formTypeSelected' : ''" @click="formCardClick('96x134-bleed')"
            class="d-flex align-items-center justify-content-center px-1 formTypeCard formTypeCardFull formTypeCardBeta formTypeCardStretch formTypeCardTop position-relative">
            <span class="formBetaBadge badge bg-warning text-dark">BETA</span>
            <div class="mt-4 mb-3 text-center row">
              <div class="col-12">
                <h4 class="fw-bold">Badge 10 x 13</h4>
                <p class="m-0 small">avec fond perdu</p>
              </div>
            </div>
          </div>
          <div :class="selected === '96x268-bleed' ? 'formTypeSelected' : ''" @click="formCardClick('96x268-bleed')"
            class="d-flex align-items-center justify-content-center formTypeCard formTypeCardFull formTypeCardBeta formTypeCardRV">
            <span class="fw-bold">Recto verso différent</span>
          </div>
        </div>
        <div style="width: 220px" aria-hidden="true"></div>
      </div>
      <div class="d-flex align-items-center justify-content-center h-25 row">
        <div class="text-center col-12" v-if="mode === 'start'">
          <button :disabled="selected === ''" :class="selected === '' ? 'btn-outline-dark' : ' text-light btn-success'" @click="validateClick"
            class="btn btn-lg">
            {{ dictionary.continue.toUpperCase() }}
          </button>
        </div>
        <div class="col-12">
          <input @change="readImportData" accept="application/JSON" ref="importHiddenInput" type="file" style="visibility: hidden" />
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import VueNotifications from 'vue-notifications';
import { mapGetters } from 'vuex';
import BadgeDefaultContent from '../configuration/BadgeDefaultContent.json';

export default {
  name: 'NewWebsiteWizzard',
  data() {
    return {
      selected: '',
      mode: 'start',
    };
  },
  computed: {
    ...mapGetters(['dictionary']),
  },
  methods: {
    importWebsite(content) {
      this.$store.commit('setBadgeContent', { content });
    },
    formCardClick(selected) {
      this.selected = selected;
    },
    validateClick() {
      if (this.selected === 'import') {
        this.$refs.importHiddenInput.click();
      } else {
        const isRV = this.selected.endsWith('-rv');
        const baseSelected = isRV ? this.selected.replace('-rv', '') : this.selected;
        const content = { ...BadgeDefaultContent[baseSelected], origin: baseSelected };
        if (isRV && content.format) {
          content.format = { ...content.format, ratioY: content.format.ratioY * 2 };
        }
        this.$store.commit('setBadgeContent', { content, dbSync: true });
      }
    },
    readImportData(ev) {
      const file = ev.target.files[0];
      const reader = new FileReader();

      reader.onload = (e) => {
        try {
          const object = JSON.parse(e.target.result);
          if (object) this.importWebsite(object);
        } catch (ex) {
          console.log(`Invalid badge content file : ${ex.message}`);
        }
      };
      reader.readAsText(file);
    },
  },
  notifications: {
    websiteImported: {
      type: VueNotifications.types.success,
      title: 'Badge importé !',
      message: 'Le badge a été importé avec succès',
    },
    blankSiteCreated: {
      type: VueNotifications.types.success,
      title: 'Badge crée !',
      message: 'Amusez vous bien :)',
    },
  },
};
</script>

<style scoped>
.formTypeCard {
  border-radius: 15px;
  color: white;
  cursor: pointer;
  width: 220px;
}

.formTypeCardTop {
  border-bottom-left-radius: 5px;
  border-bottom-right-radius: 5px;
}

.formTypeCardRV {
  border-radius: 15px;
  border-top-left-radius: 5px;
  border-top-right-radius: 5px;
  width: 100%;
  height: 40px;
  font-size: 0.8rem;
  text-align: center;
  flex-shrink: 0;
}

.formTypeCardStretch {
  flex: 1;
}

.formTypeCardFull {
  background-color: var(--bs-secondary);
  border: 2px solid var(--bs-secondary);
}

.formTypeCardBeta {
  background-color: #545B62;
  border: 2px solid #545B62;
}

.formTypeCard.formTypeCardBeta:not([disabled]):hover {
  border: 2px solid var(--bs-primary);
  color: var(--bs-primary);
}

.formBetaBadge {
  position: absolute;
  top: 8px;
  right: 8px;
}

.formTypeCardOutline {
  border: 2px solid var(--bs-secondary);
  color: var(--bs-secondary);
}

.formTypeSelected {
  border: 2px solid var(--bs-primary);
  color: var(--bs-primary);
}

.formTypeCard:not([disabled]):hover {
  border: 2px solid var(--bs-primary);
  color: var(--bs-primary);
}
</style>
